import { createApp } from 'vue';
import router from './router.js';
import store from './store/index.js';
import App from './App.vue';

// UI Components
import BaseCard from './components/ui/BaseCard.vue';
import BaseButton from './components/ui/BaseButton.vue';
import BaseBadge from './components/ui/BaseBadge.vue';
import BaseSpinner from './components/ui/BaseSpinner.vue';
import BaseDialog from './components/ui/BaseDialog.vue';
import GlobalDialog from './pages/common/GlobalDialog.vue';

// Plugins
import vuetify from './plugins/vuetify'; // Make sure this file properly creates and exports your Vuetify instance
import '@mdi/font/css/materialdesignicons.css';

const app = createApp(App);

// Use Plugins
app.use(vuetify);
app.use(router);
app.use(store);

// Register Global Components
app.component('BaseCard', BaseCard);
app.component('BaseButton', BaseButton);
app.component('BaseBadge', BaseBadge);
app.component('BaseSpinner', BaseSpinner);
app.component('BaseDialog', BaseDialog);
app.component('GlobalDialog', GlobalDialog);


router.isReady().then(() => {
  app.mount('#app');
});